import {
  Button,
  Group,
  Loader,
  Paper,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import {
  IconBrandLinkedin,
  IconDeviceMobile,
  IconPlus,
  IconUserSearch,
} from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useEffect, useMemo, useState } from "react";
import { getProfile, updateSelf } from "../../../../api/UserAPI";
import { IconEmail } from "../../../../assets/icons/IconEmail";
import { useAccountsStore } from "../../../../stores/ConfigStore";
import { useProfileStore } from "../../../../stores/UserStore";

const ResellerInfo = ({ tableLoading, reseller, profile, setProfile }) => {
  const lang = useLanguage((s) => s.language);
  const linkedin_accounts = useAccountsStore((s) => s.linkedin_accounts);
  const email_accounts = useAccountsStore((s) => s.email_accounts);
  const accountProfile = useProfileStore((s) => s.profile);

  const [loading, setLoading] = useState(false);

  const linkedinAccounts = useMemo(() => {
    return profile?.permissions?.find(
      (x) => x.name === "maxIntegrationsLinkedin",
    );
  }, [profile]);
  const emails = useMemo(() => {
    return profile?.permissions?.find(
      (x) => x.name === "maxIntegrationsEmailSMTP",
    );
  }, [profile]);
  const enrichments = useMemo(() => {
    return profile?.permissions?.find(
      (x) => x.name === "maxEmailsGeneratedPerMonth",
    );
  }, [profile]);
  const mobiles = useMemo(() => {
    return profile?.permissions?.find(
      (x) => x.name === "maxMobilePhonesGeneratedPerMonth",
    );
  }, [profile]);

  const personalUsedLinkedin = useMemo(() => {
    return linkedin_accounts.filter((x) => !x.from_sharing).length;
  }, [linkedin_accounts]);

  const personalUsedEmails = useMemo(() => {
    return email_accounts.filter((x) => !x.from_sharing).length;
  }, [email_accounts]);

  const availableLinkedin = useMemo(() => {
    return Math.max(0, (linkedinAccounts?.value || 0) - personalUsedLinkedin);
  }, [linkedinAccounts, personalUsedLinkedin]);

  const availableEmails = useMemo(() => {
    return Math.max(0, (emails?.value || 0) - personalUsedEmails);
  }, [emails, personalUsedEmails]);

  useEffect(() => {
    if (tableLoading) {
      setLoading(true);
      updateSelf(true, reseller?.id)
        .then((res) => {
          if (res.data?.user_profile?.id === accountProfile?.id) {
            setProfile(res.data.user_profile);
          } else {
            getProfile(accountProfile?.id, true).then((res) => {
              setProfile(res.data.user_profile);
            });
          }
        })
        .finally(() => setLoading(false));
    }
  }, [reseller?.id, tableLoading]);

  // if (profile?.level !== "admin" && profile.id !== reseller?.created_by) {
  //   return "";
  // }

  return (
    <Paper component={Group} gap={"lg"} p={"xs"} pl={"xl"} flex={1}>
      <Text size="lg" fw={600} mr={32}>
        {lang.white_labels.your_credits}
      </Text>
      <Tooltip
        label={`${lang.resellers.info.assign} ${availableLinkedin} ${
          lang.resellers.info.linkedin
        }`}
      >
        <Group
          gap={"md"}
          // style={{ border: "1px solid #00000016", borderRadius: 12 }}
          // p={"xs"}
          // pr={18}
          flex={1}
          justify="center"
        >
          {loading ? (
            <Loader size={32} />
          ) : (
            <ThemeIcon variant="filled" size={32} radius={"md"} color="blue">
              <IconBrandLinkedin size={24} />
            </ThemeIcon>
          )}
          <Text fw={600} size="lg">
            {availableLinkedin}
          </Text>
          <span>/</span>
          <Text fw={600} size="lg">
            {linkedinAccounts?.default_value || 0}
          </Text>
        </Group>
      </Tooltip>

      <Tooltip
        label={`${lang.resellers.info.assign} ${availableEmails} ${
          lang.resellers.info.emails
        }`}
      >
        <Group gap={"md"} flex={1} justify="center">
          {loading ? (
            <Loader size={32} />
          ) : (
            <ThemeIcon
              variant="filled"
              size={32}
              radius={"md"}
              color="secondary"
            >
              <IconEmail size={24} />
            </ThemeIcon>
          )}
          <Text fw={600} size="lg">
            {availableEmails}
          </Text>
          <span>/</span>
          <Text fw={600} size="lg">
            {emails?.default_value || 0}
          </Text>
        </Group>
      </Tooltip>

      <Tooltip
        label={`${lang.resellers.info.assign} ${enrichments?.value || 0} ${
          lang.resellers.info.credits
        }`}
      >
        <Group gap={"md"} flex={1} justify="center">
          {loading ? (
            <Loader size={32} />
          ) : (
            <ThemeIcon variant="filled" size={32} radius={"md"} color="green">
              <IconUserSearch size={24} />
            </ThemeIcon>
          )}
          <Text fw={600} size="lg">
            {enrichments?.value || 0}
          </Text>
          <span>/</span>
          <Text fw={600} size="lg">
            {enrichments?.default_value || 0}
          </Text>
        </Group>
      </Tooltip>

      <Tooltip
        label={`${lang.resellers.info.assign} ${mobiles?.value || 0} ${
          lang.resellers.info.mobiles
        }`}
      >
        <Group gap={"md"} flex={1} justify="center">
          {loading ? (
            <Loader size={32} />
          ) : (
            <ThemeIcon variant="filled" size={32} radius={"md"}>
              <IconDeviceMobile size={24} />
            </ThemeIcon>
          )}
          <Text fw={600} size="lg">
            {mobiles?.value || 0}
          </Text>
          <span>/</span>
          <Text fw={600} size="lg">
            {mobiles?.default_value || 0}
          </Text>
        </Group>
      </Tooltip>

      <Button
        size="md"
        component={Link}
        to={"/settings/subscription"}
        ml={8}
        leftSection={<IconPlus size={24} />}
        variant="subtle"
        color="primary"
      >
        {lang.resellers.info.add_more}
      </Button>
    </Paper>
  );
};

export default ResellerInfo;
